<script lang="ts">
  import { Button,  Form, FormGroup, Input, InputGroup, InputGroupText, Label } from "sveltestrap";
  import { CreateAccount, CreateYourPassword, Done, Donthaveaccount, NewPassword, Password, Rememberpassword, href } from "../../../../../utils/Constant/Constant";
  import Link from "svelte-link";
</script>
<Form class="theme-form login-form">
    <h4>{CreateYourPassword}</h4>
    <FormGroup>
        <Label>{NewPassword}</Label>
        <InputGroup>
            <InputGroupText>
                <i class="icon-lock"></i>
            </InputGroupText>
            <Input type="password" name="login[password]" required placeholder="*********" />
            <div class="show-hide">
                <span class="show"></span>
            </div>
        </InputGroup>
    </FormGroup>
    <FormGroup>
        <Label>{Password}</Label>
        <InputGroup>
            <InputGroupText>
                <i class="icon-lock"></i>
            </InputGroupText>
            <Input type="password" name="login[password]" required placeholder="*********" />
        </InputGroup>
    </FormGroup>
    <FormGroup>
        <div class="checkbox">
            <Input id="checkbox1" type="checkbox" />
            <Label class="text-muted" for="checkbox1">{Rememberpassword}</Label>
        </div>
    </FormGroup>
    <FormGroup>
        <Button color="primary" class="btn-block" type="submit">{Done}</Button>
    </FormGroup>
    <p>{Donthaveaccount}
        <Link class="ms-2" href={href}>{CreateAccount}</Link>
    </p>
</Form>